import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hasRole, type Role } from "./types";
import { useSession } from "./useSession";

export function RequireAuth({ roles }: { roles?: Role[] }) {
  const session = useSession();
  const location = useLocation();
  const { t } = useTranslation();
  if (session.isPending) return <p className="bt-page-message">{t("app.loading")}</p>;
  if (!session.data?.authenticated) {
    return (
      <Navigate to="/auth/login" replace state={{ from: location.pathname + location.search }} />
    );
  }
  if (roles && !hasRole(session.data.user, ...roles)) {
    return <p className="bt-page-message bt-page-message--error">{t("auth.forbidden")}</p>;
  }
  return <Outlet />;
}
